import { render, staticRenderFns } from "./listFriend.vue?vue&type=template&id=46528827"
import script from "./listFriend.vue?vue&type=script&lang=js"
export * from "./listFriend.vue?vue&type=script&lang=js"
import style0 from "./listFriend.vue?vue&type=style&index=0&id=46528827&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports